import React, { Component } from 'react'
import Header from '../Components/header/index.jsx'
import Footer from '../Components/Footer/index'
import './index.scss'

class index extends Component {
  componentWillMount() {
    document.title = '高温温湿度_温湿度_智慧物联网_大数据平台_数字孪生_北京锐控自动化科技有限公司|锐控生态'
  }
  render() {
    return (
      <div>
        <Header></Header>
        <div className="shengtaiContent">
          <div className="shengtaiContent-title">
            <div className="shengtaiContent-title-h1">锐控生态</div>
            <div className="shengtaiContent-title-text">聚焦数字化 / 企业智能化</div>
          </div>
        </div>
        <div className="shengtai-details">
          <div className="shengtai-details-title">
            <div className="shengtai-details-title-top">基于工业互联网、物联网、GIS、AI等技术, 满足了不同企业的需求</div>
            <div className="shengtai-details-title-content">
              <img style={{ marginRight: '1rem' }} className="shengtai-details-title-content-item" src={require('../image/shengtai1.png')} alt="" />
              <div className="shengtai-details-title-content-item">在2021年、北京锐控正式宣布“锐控生态伙伴”计划，与行业顶尖的伙伴企业一起，为客户提供更稳妥、高效、动态升级的服务能力。我们联合哈尔滨理工大学测控技术与通信工程学院和哈尔滨工业大学计算机学院多智能体机器人研究中心成立了专家委员会， 联合北京本地众多科技公司形成生态圈，共同研究技术，分享经验成果。北京锐控与哈尔滨工业大学计算机院共同申请，获得了唐山政府颁发的“唐山市企业诊所”牌照，目前正在申请河北政府的“河北工业诊所”牌照，帮助当地政府解决当地企业数字化转型的问题。在山东滨州，与腾讯，阿里等一批一线企业即将共同被纳入滨州市政府为本地企业智能化改造升级的第一批专家委员会成员，获批多项优惠政策。</div>
            </div>
          </div>
          <div className="shengtai-details-title-h1">
            <div style={{ marginBottom: '0.5rem', fontSize: '1.2rem', fontWeight: 600 }}>锐控生态伙伴</div>
            <div className="shengtai-details-title-h1-border"></div>
            <div className="shengtai-details-title-h1-border1"></div>
          </div>
          <div className="shengtai-text">
            北京锐控自动化科技有限公司，擅长工业数据采集、设备控制、界面软件系统
            <br />
            北京志金合力工控技术发展有限公司，传感器、控制器制造商
            <br />
            华海自动化设备（北京）有限公司，擅长现场自控系统工程，主要从事汽车生产线的机械控制
            <br />
            北京永道创鑫科技有限公司,主要从事安全领域管理系统、OA、园区管理等互联网软件定制研发、安全等保测试、系统集成
            <br />
            北京盖倍特科技有限公司，擅长工业软件定制开发
            <br />
            北京尔希科技有限公司，擅长数字孪生三维展示技术
            <br />
            北京鼎创恒达智能科技有限公司，擅长工业现场移动设备数据采集与控制
            <br />
          </div>
        </div>

        <Footer titleIshow={false}></Footer>
      </div>
    )
  }
}

export default index
